import React, { useState , useEffect} from 'react';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ModalRemoveToken from '../../common/modals/modalRemoveToken/ModalRemoveToken';
import FormSearch from '../../common/forms/FormSearch';
import {axiosApiInstance} from '../../../services/axios';
import Button from "../../common/button/Button" ;
import Pagination from '../../common/pagination/Pagination';
import Loading from '../../common/loading/Loading';
import ModalLoading from '../../common/modals/modalLoading/ModalLoading';

const Tokens = () => {


    const [showModalRemoveToken, setShowModalRemoveToken] = useState(false);
    const[loading , setLoading] = useState(true);
    const [tokens, setTokens] = useState();
    const [page, setPage] = useState();
    const [pages, setPages] = useState();
    const [currentToken , setCurrentToken] = useState({});
    const [loadingForm , setLoadingForm] = useState(false);
    const [ form ]= useState({
        formItems: [
            {
                inputType: "input",
                config: {
                    name: "key",
                    placeholder : "Search"
                },
                value: '',
                validation: {
                },
                valid: false,
                errorMsg: "",
                used: false
            },
        ]
    });

    const stateModalRemoveToken = (state , item) => {
        setShowModalRemoveToken(state);
        setCurrentToken(item);
    }

    useEffect(()=>{
        const getTokens = async()=>{
            const res = await axiosApiInstance.get('/admin/tokens' );
            setLoading(false);
            if(res.data.status === 'success'){
                setTokens(res.data.data.tokens);
                setPage(res.data.data.tokens.page);
                setPages(res.data.data.tokens.pages);

            }else if(res.data.status === 'error'){
                toast.error(res.data.msg);
            }
        }
        getTokens();
    } , []);



    const goPage = async (p) => {
        setLoading(true);
        const res = await axiosApiInstance.get(`/admin/tokens?page=${p}`);
        setLoading(false);
        if (res.data.status === 'success') {
            setTokens(res.data.data.tokens);
            setPage(res.data.data.tokens.page);
            setPages(res.data.data.tokens.pages);
        } else {
            toast.error(res.data.msg);
        }
    }


    const refresh = () => {
        goPage(page);
    }


    const handleFormSearch = async(q)=>{

        setLoadingForm(true);
        
        const res = await axiosApiInstance.get(`/admin/tokens?q=${q}`);
        setLoadingForm(false);
        if (res.data.status === 'success') {
            setTokens(res.data.data.tokens);
            setPage(res.data.data.tokens.page);
            setPages(res.data.data.tokens.pages);
        } else {
            toast.error(res.data.msg);
        }

    }

    return (
        <>

            <ModalLoading show={loadingForm}/>
            <ModalRemoveToken show={showModalRemoveToken} close={()=>stateModalRemoveToken(false)} refresh={() => refresh()} item={currentToken}/>

            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <div className="container mx-auto p-3 ">

                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>

                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 dark:fill-white-100 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 dark:text-white-100 text-xl font-extrabold'>Tokens</span>
                    </div>


                    {
                        loading ? 
                        (
                            <Loading />

                        )
                        :
                        (
                            <div className='w-full flex flex-col justify-center items-start'>
                                <div className='w-full flex items-center justify-between text-base font-semibold	 mb-4 text-slate-600 dark:text-white-100'>
                                    List of all tokens
                                    <FormSearch classesForm='w-[400px]' initForm={form} submit={handleFormSearch}/>
                                </div>
                                <div className='w-full text-[0.9rem] text-center border-collapse overflow-x-auto'>
                                    {tokens.docs.length > 0 ?
                                        (
                                            <>
                                                <table className="w-full table">
                                                    <thead>
                                                        <tr>
                                                            <th className='min-w-[120px] text-gray-800 text-[1rem] font-bold border-none align-middle h-20'>User</th>
                                                            <th className='min-w-[120px] text-gray-800 text-[1rem] font-bold border-none  align-middle h-20'>Type</th>
                                                            <th className='min-w-[120px] text-gray-800 text-[1rem] font-bold border-none align-middle h-20'>Value</th>
                                                            <th className='min-w-[120px] text-gray-800 text-[1rem] font-bold border-none align-middle h-20'>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        { tokens.docs.map ((token , index) =>(
                                                            <tr key={index} className="hover:bg-stone-100">
                                                               
                                                                <td className='font-semibold text-[1rem] text-gray-700 border-none align-middle h-20'>{ token.user.email || token.user.phone }</td>
                                                                <td className='font-semibold text-[1rem] text-gray-700 border-none align-middle h-20'>{ token.tokentype.title }</td>
                                                                <td className='font-semibold text-[1rem] text-gray-700 border-none align-middle h-20'>{token.value}</td>

                                                                <td className='flex items-center justify-center font-semibold text-[1rem] text-gray-700 border-none align-middle h-20'>
                                                                    <Button classes="px-2 py-1 bg-red-600" click={()=>stateModalRemoveToken(true , token)} >
                                                                        Remove
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                            )
                                                        )
                                                        }

                                                    </tbody>
                                                </table>
                                                <Pagination pages={pages} current={page} action={goPage} />
                                            </>

                                        )
                                        :
                                        (

                                            <p className="caption-no-result">
                                                No user found
                                            </p>

                                        )
                                    }

                                </div>
                            </div> 
                        )
                    }

                </div>

            </div>
        </>
    )

}

export default Tokens ;
